import { Injectable } from '@angular/core';
import { EntityState, StoreConfig, EntityStore } from '@datorama/akita';
import { GlobalAppState } from './global.appstate.model';

export interface GlobalState extends EntityState<GlobalAppState, number> {
  ui: {
    muted: boolean;
    selectedServerName?: string;
  };

}

const initialState = {
  ui: { muted: false},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'globalState' })
export class GlobalStateStore extends EntityStore<GlobalState> {


  constructor() {
    super(initialState);
  }

  updateMute(muted: boolean) {
    this.update(state => ({
      ui: {
        ...state.ui,
        muted
      }
    }));
  }

  updateSelectedServerName(name: string) {
    this.update(state => ({
      ui: {
        ...state.ui,
        selectedServerName: name
      }
    }));
  }
}
